import React from 'react'

/**
 * Decorative constellation behind the product grid, ported verbatim from the
 * reference design. Sparser than the hero's and anchored to the left edge, so the
 * two never read as the same artwork repeated.
 */
const ProductsConstellation = () => (
  <svg
    className='mic-home-artwork'
    viewBox='0 0 1440 360'
    preserveAspectRatio='xMinYMid slice'
    aria-hidden='true'
    focusable='false'
  >
    <g stroke='#4fd691' strokeWidth='.9' fill='none'>
      <line x1='26.6' y1='311.1' x2='16.9' y2='316.6' strokeOpacity='0.133' />
      <line x1='682.5' y1='334.6' x2='702.4' y2='355.4' strokeOpacity='0.081' />
      <line x1='539.6' y1='179.6' x2='519.6' y2='214.0' strokeOpacity='0.085'>
        <animate attributeName='stroke-opacity' values='0.085;0.195;0.085' dur='11s' repeatCount='indefinite' />
      </line>
      <line x1='26.6' y1='311.1' x2='5.0' y2='274.1' strokeOpacity='0.123' />
      <line x1='16.9' y1='316.6' x2='5.0' y2='274.1' strokeOpacity='0.134' />
      <line x1='26.6' y1='311.1' x2='65.8' y2='339.0' strokeOpacity='0.121' />
      <line x1='16.9' y1='316.6' x2='65.8' y2='339.0' strokeOpacity='0.127' />
      <line x1='519.6' y1='214.0' x2='566.4' y2='244.3' strokeOpacity='0.089' />
      <line x1='222.6' y1='238.0' x2='204.6' y2='292.8' strokeOpacity='0.103' />
      <line x1='65.8' y1='339.0' x2='129.9' y2='333.4' strokeOpacity='0.097' />
      <line x1='539.6' y1='179.6' x2='566.4' y2='244.3' strokeOpacity='0.080' />
      <line x1='224.6' y1='165.2' x2='222.6' y2='238.0' strokeOpacity='0.112' />
      <line x1='204.6' y1='292.8' x2='279.4' y2='305.4' strokeOpacity='0.099' />
      <line x1='554.3' y1='321.9' x2='566.4' y2='244.3' strokeOpacity='0.096'>
        <animate attributeName='stroke-opacity' values='0.096;0.220;0.096' dur='15s' repeatCount='indefinite' />
      </line>
      <line x1='5.0' y1='274.1' x2='80.9' y2='244.8' strokeOpacity='0.098' />
      <line x1='222.6' y1='238.0' x2='279.4' y2='305.4' strokeOpacity='0.100' />
      <line x1='65.8' y1='339.0' x2='5.0' y2='274.1' strokeOpacity='0.115' />
      <line x1='1084.9' y1='211.0' x2='1091.7' y2='311.9' strokeOpacity='0.071' />
      <line x1='129.9' y1='333.4' x2='80.9' y2='244.8' strokeOpacity='0.088' />
      <line x1='369.9' y1='242.6' x2='429.2' y2='324.9' strokeOpacity='0.081' />
      <line x1='279.4' y1='305.4' x2='369.9' y2='242.6' strokeOpacity='0.080' />
      <line x1='682.5' y1='334.6' x2='726.6' y2='230.3' strokeOpacity='0.070' />
      <line x1='429.2' y1='324.9' x2='554.3' y2='321.9' strokeOpacity='0.079' />
      <line x1='554.3' y1='321.9' x2='682.5' y2='334.6' strokeOpacity='0.068' />
      <line x1='224.6' y1='165.2' x2='204.6' y2='292.8' strokeOpacity='0.085'>
        <animate attributeName='stroke-opacity' values='0.085;0.196;0.085' dur='12s' repeatCount='indefinite' />
      </line>
      <line x1='421.1' y1='372.9' x2='369.9' y2='242.6' strokeOpacity='0.074' />
      <line x1='539.6' y1='179.6' x2='554.3' y2='321.9' strokeOpacity='0.069' />
      <line x1='429.2' y1='324.9' x2='519.6' y2='214.0' strokeOpacity='0.073' />
      <line x1='222.6' y1='238.0' x2='369.9' y2='242.6' strokeOpacity='0.073' />
      <line x1='279.4' y1='305.4' x2='429.2' y2='324.9' strokeOpacity='0.074' />
      <line x1='80.9' y1='244.8' x2='224.6' y2='165.2' strokeOpacity='0.077' />
      <line x1='1091.7' y1='311.9' x2='1262.6' y2='272.0' strokeOpacity='0.061' />
      <line x1='421.1' y1='372.9' x2='519.6' y2='214.0' strokeOpacity='0.065' />
      <line x1='1084.9' y1='211.0' x2='1262.6' y2='272.0' strokeOpacity='0.061' />
      <line x1='539.6' y1='179.6' x2='726.6' y2='230.3' strokeOpacity='0.059' />
    </g>
    <g fill='#6ce2a8'>
      <circle cx='26.6' cy='311.1' r='1.9' fillOpacity='0.26' />
      <circle cx='16.9' cy='316.6' r='1.6' fillOpacity='0.28' />
      <circle cx='65.8' cy='339.0' r='3.5' fillOpacity='0.47'>
        <animate attributeName='fill-opacity' values='0.47;0.90;0.47' dur='10s' repeatCount='indefinite' />
      </circle>
      <circle cx='5.0' cy='274.1' r='2.5' fillOpacity='0.30' />
      <circle cx='129.9' cy='333.4' r='1.9' fillOpacity='0.22' />
      <circle cx='80.9' cy='244.8' r='2.7' fillOpacity='0.23' />
      <circle cx='224.6' cy='165.2' r='1.2' fillOpacity='0.26' />
      <circle cx='222.6' cy='238.0' r='2.0' fillOpacity='0.26' />
      <circle cx='204.6' cy='292.8' r='1.5' fillOpacity='0.23' />
      <circle cx='279.4' cy='305.4' r='1.8' fillOpacity='0.24'>
        <animate attributeName='fill-opacity' values='0.24;0.46;0.24' dur='11s' repeatCount='indefinite' />
      </circle>
      <circle cx='421.1' cy='372.9' r='1.3' fillOpacity='0.24' />
      <circle cx='369.9' cy='242.6' r='4.3' fillOpacity='0.41' />
      <circle cx='429.2' cy='324.9' r='4.0' fillOpacity='0.41' />
      <circle cx='539.6' cy='179.6' r='3.3' fillOpacity='0.40' />
      <circle cx='554.3' cy='321.9' r='1.5' fillOpacity='0.24' />
      <circle cx='519.6' cy='214.0' r='4.1' fillOpacity='0.41' />
      <circle cx='566.4' cy='244.3' r='2.4' fillOpacity='0.23'>
        <animate attributeName='fill-opacity' values='0.23;0.43;0.23' dur='12s' repeatCount='indefinite' />
      </circle>
      <circle cx='682.5' cy='334.6' r='2.3' fillOpacity='0.19' />
      <circle cx='726.6' cy='230.3' r='2.0' fillOpacity='0.19' />
      <circle cx='702.4' cy='355.4' r='1.6' fillOpacity='0.22' />
      <circle cx='1084.9' cy='211.0' r='3.3' fillOpacity='0.39' />
      <circle cx='1091.7' cy='311.9' r='2.6' fillOpacity='0.19' />
      <circle cx='1262.6' cy='272.0' r='3.8' fillOpacity='0.39' />
    </g>
  </svg>
)

export default ProductsConstellation
